import { Box } from "@mui/material";
import { useAppSelector } from "../../../../../../Redux/hooks";
import { ConsentListStyle } from "../../../../../EConsent/Builder/block.style";

import ConsentBlock from "./ConsentBlock";
import "../../../../../QuestionBuilder/QuestionPreview/questionpreview.scss";

const ConsentBlockWrapper = () => {
  const blocks = useAppSelector((state) => state.providerConsent.blocks);
  return (
    <Box sx={{ ...ConsentListStyle, p: 1 }}>
      <Box
        sx={{
          width: "60%",
          bgcolor: "#FFFFFF",
          margin: "0 auto",
          p: 4,
          borderRadius: "12px",
          my: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          backgroundColor: "#fff",
          boxShadow: "0px 0px 12px 0px #00000014",
        }}
      >
        {blocks.length > 0
          ? blocks.map((block, index) => {
              return (
                <ConsentBlock block={block} index={index} key={block.id} />
              );
            })
          : null}
      </Box>
    </Box>
  );
};

export default ConsentBlockWrapper;
